/**
 * Bounds and allowed values for the Statsig experiment parameters this app
 * reads.
 */

/** Buckets the guest fee discount experiment may put a guest in. */
const GUEST_FEE_DISCOUNT_BUCKETS = [
  "full",
  "25_percent_off",
  "50_percent_off",
] as const;

/** Longest minimum we will honour, so a mis-typed parameter cannot lock guests out. */
const MAX_REVIEW_MIN_LENGTH = 1000;

export { GUEST_FEE_DISCOUNT_BUCKETS, MAX_REVIEW_MIN_LENGTH };
